// extracted by mini-css-extract-plugin
module.exports = {"redirectIcon":"RedirectIcon_redirectIcon__2zm-6","headerClickArea":"RedirectIcon_headerClickArea__w71EX"};